<template>
  <div class="expired-container">
    <div class="expired-orb expired-orb-1"></div>
    <div class="expired-orb expired-orb-2"></div>

    <div class="expired-card">
      <div class="expired-icon">
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10" />
          <line x1="12" y1="8" x2="12" y2="12" />
          <line x1="12" y1="16" x2="12.01" y2="16" />
        </svg>
      </div>

      <h1 class="expired-title">{{ isNoPlan ? 'No plan assigned' : 'Your plan has expired' }}</h1>
      <p class="expired-desc">
        <template v-if="isNoPlan">
          This feature isn't available because your company doesn't have a subscription
          plan yet. Please contact your company administrator to get one assigned.
        </template>
        <template v-else>
          Access to BidSnap AI has been paused because your company's subscription
          plan is no longer active. Please contact your company administrator to
          renew and restore full access.
        </template>
      </p>

      <div class="expired-actions">
        <button v-if="isNoPlan" class="expired-btn expired-btn-secondary" @click="goToDashboard">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
          </svg>
          Back to Dashboard
        </button>
        <button class="expired-btn expired-btn-primary" @click="logout">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
            <polyline points="16 17 21 12 16 7" />
            <line x1="21" y1="12" x2="9" y2="12" />
          </svg>
          Log Out
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PlanExpired',
  computed: {
    isNoPlan() {
      return this.$route.query.reason === 'no_plan';
    }
  },
  methods: {
    goToDashboard() {
      this.$router.push({ name: 'Tenders' });
    },
    logout() {
      localStorage.removeItem('user-info');
      localStorage.removeItem('user-name');
      this.$router.push({ name: 'LoginPage' });
    }
  }
};
</script>

<style scoped>
.expired-container {
  position: relative;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #1c0f0f 0%, #2a1414 50%, #1c0f0f 100%);
  padding: 24px;
  overflow: hidden;
}

.expired-orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(80px);
  opacity: 0.5;
  pointer-events: none;
}

.expired-orb-1 {
  width: 400px;
  height: 400px;
  background: radial-gradient(circle, #f43f5e, transparent);
  top: -120px;
  left: -120px;
  animation: expired-float 8s ease-in-out infinite;
}

.expired-orb-2 {
  width: 360px;
  height: 360px;
  background: radial-gradient(circle, #f59e0b, transparent);
  bottom: -100px;
  right: -100px;
  animation: expired-float 10s ease-in-out infinite reverse;
}

@keyframes expired-float {
  0%, 100% { transform: translate(0, 0); }
  50% { transform: translate(30px, -30px); }
}

.expired-card {
  position: relative;
  z-index: 1;
  max-width: 480px;
  width: 100%;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(20px);
  border-radius: 20px;
  padding: 48px 40px;
  text-align: center;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  animation: expired-fade-in 0.5s ease-out;
}

@keyframes expired-fade-in {
  from { opacity: 0; transform: translateY(12px); }
  to { opacity: 1; transform: translateY(0); }
}

.expired-icon {
  width: 80px;
  height: 80px;
  margin: 0 auto 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: linear-gradient(135deg, rgba(244, 63, 94, 0.2), rgba(245, 158, 11, 0.2));
  color: #fb7185;
  border: 1px solid rgba(251, 113, 133, 0.3);
}

.expired-title {
  font-size: 24px;
  font-weight: 700;
  color: #f1f5f9;
  margin: 0 0 12px;
}

.expired-desc {
  font-size: 15px;
  line-height: 1.6;
  color: #94a3b8;
  margin: 0 0 32px;
}

.expired-actions {
  display: flex;
  gap: 12px;
  justify-content: center;
  flex-wrap: wrap;
}

.expired-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 22px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid transparent;
}

.expired-btn-primary {
  background: linear-gradient(135deg, #f43f5e, #f59e0b);
  color: #fff;
  box-shadow: 0 6px 20px rgba(244, 63, 94, 0.35);
}

.expired-btn-primary:hover {
  transform: translateY(-1px);
  box-shadow: 0 8px 24px rgba(244, 63, 94, 0.45);
}

@media (max-width: 480px) {
  .expired-card { padding: 36px 24px; }
  .expired-title { font-size: 20px; }
  .expired-actions { flex-direction: column; }
  .expired-btn { width: 100%; justify-content: center; }
}
</style>
